/**
 * These are the possible combinations for odds ordering,
 * according to selection types
 */
export const selectionsOrdering = {
    PointBox: {
        0: ["", ""],
        1: ["Over", "Under"]
    },
    ThreeBox: {
        0: ["", "", ""],
        1: ["Home", "Tie", "Away"],
        2: ["Home", "Draw", "Away"],
        3: ["1X", "X2", "12"],
        4: ["Over", "Exactly", "Under"],
        5: ["ToScoreFirst", "ToScoreLast", "ToScoreAnyTime"],
        6: ["ToScoreFirstOrLast", "ToScore2OrMore", "ToScore3OrMore"]
    },
    TwoBox: {
        0: ["", ""],
        1: ["Home", "Away"],
        2: ["Over", "Under"],
        3: ["Yes", "No"],
        4: ["Odd", "Even"]
    }
}
